<template>
    <div>
        <b-container
            class="mt-2"
            fluid
        >
            <b-row>
                <b-col>
                    <span
                        class="text-bold"
                    >
                        Action
                    </span>
                </b-col>
                <b-col
                    cols="12"
                >
                    <b-button-group
                        size="sm"
                    >
                        <b-button
                            variant="primary"
                            :pressed="mode === modeAdd"
                            :style="isDark ? (mode === modeAdd ? 'background: #f89624 !important; color: white !important;' : 'border: 1px solid #f89624 !important; background: #283046 !important; color: #f89624 !important;') : (mode === modeAdd ? 'background: #f89624 !important; color: white !important;' : 'border: 1px solid #f89624 !important; background: white !important; color: #f89624 !important;')"
                            @click="switchMode(modeAdd)"
                        >
                            Add
                        </b-button>
                        <b-button
                            variant="primary"
                            :pressed="mode === modeRemove"
                            :style="isDark ? (mode === modeRemove ? 'background: #f89624 !important; color: white !important;' : 'border: 1px solid #f89624 !important; background: #283046 !important; color: #f89624 !important;') : (mode === modeRemove ? 'background: #f89624 !important; color: white !important;' : 'border: 1px solid #f89624 !important; background: white !important; color: #f89624 !important;')"
                            @click="switchMode(modeRemove)"
                        >
                            Remove
                        </b-button>
                    </b-button-group>
                </b-col>
            </b-row>
            <b-row
                class="mt-2"
            >
                <b-col
                    cols="12"
                >
                    <span
                        class="bold"
                    >
                        Barcode
                    </span>
                </b-col>
            </b-row>
            <b-row>
                <b-col
                    cols="9"
                >
                    <b-form-input
                        id="add-item__code"
                        ref="add-item__code"
                        v-model="code"
                        autofocus
                        placeholder="Scan your product here"
                        :disabled="loading"
                        @keyup.enter="scan(false)"
                    />
                </b-col>
                <b-col
                    cols="3"
                    align-self="center"
                >
                    <b-button
                        variant="success"
                        size="md"
                        class="text-center mr-2"
                        :disabled="loading"
                        @click="scan(false)"
                    >
                        {{ loading ? 'Loading...' : 'Submit' }}
                    </b-button>
                </b-col>
            </b-row>
            <b-row
                v-if="bulkScanModeEnabled"
                class="mt-1"
            >
                <b-col
                    cols="1"
                >
                    <label
                        class="col-form-label"
                    >
                        Add
                    </label>
                </b-col>
                <b-col
                    cols="3"
                >
                    <b-form-input
                        id="bulk-scan-input"
                        v-model="bulkScanQuantity"
                        size="sm"
                        type="number"
                        :disabled="loading"
                        class="custom-control-inline"
                        @keyup.enter="performBulkScan"
                    />
                </b-col>
                <b-col
                    cols="2"
                >
                    <label
                        for="bulk-scan-input"
                        class="col-form-label"
                    >
                        more to the box.
                    </label>
                </b-col>
                <b-col
                    cols="1"
                >
                    <b-button
                        variant="primary"
                        size="sm"
                        @click="performBulkScan"
                    >
                        Add
                    </b-button>
                </b-col>
            </b-row>
            <b-row
                class="mt-2"
            >
                <b-col
                    cols="12"
                >
                    <span
                        class="bold"
                    >
                        Box
                    </span>
                </b-col>
            </b-row>
            <b-row>
                <b-col
                    cols="9"
                >
                    <select v-model="selectedBoxIndex" class="form-control mb-1">
                        <option v-for="(box, index) of boxes" :value="index">
                            Box {{ box.index }}
                        </option>
                    </select>
                </b-col>
                <b-col
                    cols="3"
                    align-self="center"
                    md="auto"
                >
                    <b-button-group
                        class="text-center"
                    >
                        <b-button
                            variant="primary"
                            :disabled="boxSaving"
                            size="sm"
                            @click="addBox"
                        >
                            {{ boxSaving ? 'Loading...' : 'Add box' }}
                        </b-button>
                        <b-button
                            v-b-modal.deleteBoxModal
                            variant="danger"
                            size="sm"
                            :disabled="boxSaving"
                            class="btn-icon"
                        >
                            <feather-icon
                                icon="ArchiveIcon"
                            />
                        </b-button>
                    </b-button-group>
                </b-col>
            </b-row>
            <b-row
                class="mt-2"
            >
                <b-col
                    cols="12"
                >
                    <b-form-checkbox
                        id="add-item__copy-box-sizes"
                        v-model="copySizes"
                        :disabled="boxSaving"
                    >
                        Copy box sizes from current one when adding new box
                    </b-form-checkbox>
                </b-col>
            </b-row>
            <b-row
                class="mt-2"
            >
                <b-col
                    cols="3"
                >
                    Weight ({{ getWeightUnit() }})
                    <b-form-input
                        v-model="currentBox.weight"
                        placeholder="Box weight"
                        :disabled="boxSaving || !currentBox.id"
                        @keyup="tryToUpdateBox(currentBox)"
                    />
                </b-col>
                <b-col
                    cols="3"
                >
                    Length ({{ getLengthUnit() }})
                    <b-form-input
                        v-model="currentBox.length"
                        placeholder="Box length"
                        :disabled="boxSaving || !currentBox.id"
                        @keyup="tryToUpdateBox(currentBox)"
                    />
                </b-col>
                <b-col
                    cols="3"
                >
                    Width ({{ getLengthUnit() }})
                    <b-form-input
                        v-model="currentBox.width"
                        placeholder="Box width"
                        :disabled="boxSaving || !currentBox.id"
                        @keyup="tryToUpdateBox(currentBox)"
                    />
                </b-col>
                <b-col
                    cols="3"
                >
                    Height ({{ getLengthUnit() }})
                    <b-form-input
                        v-model="currentBox.height"
                        placeholder="Box height"
                        :disabled="boxSaving || !currentBox.id"
                        @keyup="tryToUpdateBox(currentBox)"
                    />
                </b-col>
            </b-row>
        </b-container>
        <modal-confirm-vuexy
            text="The item you just scanned has reached the maximum item count. Are you sure you want to add more items?"
            title="Confirm adding more items"
            reference="tooManyItemsModal"
            modal-id="tooManyItemsModal"
            :ok-function="addOverflowedItem"
            :cancel-function="cancelAddingOverflowItem"
        />
        <modal-confirm-vuexy
            reference="deleteBoxModal"
            modal-id="deleteBoxModal"
            title="Delete box?"
            text="Are you sure you want to delete this box?"
            :ok-function="deleteBox"
        />
    </div>
</template>

<script>
import Axios from 'axios'
import {LocalStorageSelectedBoxKey, Units} from '@/constants'
import ShipmentItemService from '../../services/ShipmentItemService'
import {
    BContainer,
    BRow,
    BCol,
    BButton,
    BButtonGroup,
    BFormInput,
    BFormCheckbox,
} from 'bootstrap-vue'
import useAppConfig from '@core/app-config/useAppConfig'
import {computed} from '@vue/composition-api'
import ModalConfirmVuexy from '@/components/Modals/ModalConfirmVuexy'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
    components: {
        BContainer,
        BRow,
        BCol,
        BButton,
        BButtonGroup,
        BFormInput,
        BFormCheckbox,
        ModalConfirmVuexy,
        // eslint-disable-next-line vue/no-unused-components
        ToastificationContent,
    },
    props: {
        boxes: {
            type: Array,
            default: () => [],
        },
        shipmentId: {
            type: Number,
            default: 0,
        },
        initialLoading: {
            type: Boolean,
            default: true,
        },
        units: {
            type: String,
            default: Units.METRIC,
        },
    },
    data() {
        return {
            modeAdd: 'add',
            modeRemove: 'remove',
            mode: 'add',
            errors: [],
            actionSuccessful: false,
            item: null,
            code: '',
            selectedBoxIndex: 0,
            quantity: 1,
            newBoxName: '',
            loading: false,
            scannedItem: null,
            forceScanItem: false,
            lastScannedItemCode: '',
            componentLoaded: false,
            bulkScanModeEnabled: false,
            bulkScanItemCode: '',
            bulkScanQuantity: 0,
            boxSaving: false,
            deleteBoxModalOpen: false,
            copySizes: true,
            boxUpdateTimeout: null,
            boxSavingWithoutDisable: false,
            currentBox: {
                height: '',
                width: '',
                length: '',
                weight: '',
            },
        }
    },
    setup() {
        const {skin} = useAppConfig()
        const isDark = computed(() => skin.value === 'dark')

        return {
            isDark,
        }
    },
    watch: {
        selectedBoxIndex(newValue) {
            localStorage.setItem(LocalStorageSelectedBoxKey, newValue)
            this.changeBox()
        },
        initialLoading() {
            if (!this.componentLoaded) {
                this.selectBoxFromLocalStorage()
            }
            this.componentLoaded = true
            this.loading = false
            this.changeBox()
        },
    },
    methods: {
        focusCodeInput() {
            this.$nextTick(() => {
                this.$refs['add-item__code'].focus()
            })
        },
        focusQuantityInput() {
            this.$nextTick(() => {
                this.$refs['add-item__qty'].focus()
            })
        },
        scan(skipResettingBulkScan) {
            if (skipResettingBulkScan !== true) {
                this.resetBulkScanMode()
            }
            if (this.loading) {
                return
            }

            this.handleBulkItemScan()

            if (this.shouldResetForceScan()) {
                this.resetForceScan()
            }

            this.errors = []
            this.loading = true
            const data = {
                box_id: this.boxes[this.selectedBoxIndex].id,
                code: this.code,
                shipment_id: this.shipmentId,
                action: this.mode,
                force_scan: this.forceScanItem,
                quantity: this.quantity,
            }

            Axios({url: `${process.env.VUE_APP_API_HTTP_ROOT}shipments/scan-item`, data, method: 'POST'})
                .then(resp => {
                    this.loading = false
                    this.scannedItem = resp.data.item
                    this.$emit('item-scanned', this.code, this.quantity, this.mode)
                    this.$emit('show-item-image', this.scannedItem)
                    this.code = ''
                    this.focusCodeInput()
                })
                .catch(err => {
                    this.playErrorSound()
                    this.focusCodeInput()

                    if (this.checkTooManyItemsScanned(err)) {
                        this.handleTooManyItemsScanned()
                    } else {
                        this.handleScanError(err)
                    }
                })
        },
        shouldResetForceScan() {
            return this.code !== this.lastScannedItemCode
        },
        resetForceScan() {
            this.forceScanItem = false
            this.lastScannedItemCode = this.code
        },
        checkTooManyItemsScanned(err) {
            return err.response.data.success === false
                && err.response.data.code
                && err.response.data.code === 'too_many_items_scanned'
        },
        handleTooManyItemsScanned() {
            this.$bvModal.show('tooManyItemsModal')
        },
        handleScanError(err) {
            this.loading = false
            for (const errorGroupKey of Object.keys(err.response.data.errors)) {
                const errorGroup = err.response.data.errors[errorGroupKey]
                this.errors = this.errors.concat(errorGroup)
            }
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: 'Whoops!',
                    icon: 'XIcon',
                    text: '' + this.errors,
                    variant: 'danger',
                },
            })
            this.code = ''
            this.focusCodeInput()
        },
        addOverflowedItem() {
            this.$bvModal.show('tooManyItemsModal')
            this.forceScanItem = true
            this.loading = false
            this.scan()
        },
        cancelAddingOverflowItem() {
            this.$bvModal.hide('tooManyItemsModal')
            this.loading = false
            this.forceScanItem = false
            this.code = ''
            this.resetBulkScanMode()
        },
        selectBoxFromLocalStorage() {
            const keyInStorage = localStorage.getItem(LocalStorageSelectedBoxKey)
            this.selectedBoxIndex = keyInStorage || 0
            if (typeof this.selectedBoxIndex !== 'number') {
                this.selectedBoxIndex = 0
            }
            // if box does not exist, select last box so at least one box is selected
            if (this.boxes.length > this.selectedBoxIndex - 1) {
                this.selectedBoxIndex = this.boxes.length - 1
            }
        },
        switchMode(mode) {
            this.mode = mode
            this.focusCodeInput()
        },
        playErrorSound() {
            const snd = new Audio('data:audio/wav;base64,//uQRAAAAWMSLwUIYAAsYkXgoQwAEaYLWfkWgAI0wWs/ItAAAGDgYtAgAyN+QWaAAihwMWm4G8QQRDiMcCBcH3Cc+CDv/7xA4Tvh9Rz/y8QADBwMWgQAZG/ILNAARQ4GLTcDeIIIhxGOBAuD7hOfBB3/94gcJ3w+o5/5eIAIAAAVwWgQAVQ2ORaIQwEMAJiDg95G4nQL7mQVWI6GwRcfsZAcsKkJvxgxEjzFUgfHoSQ9Qq7KNwqHwuB13MA4a1q/DmBrHgPcmjiGoh//EwC5nGPEmS4RcfkVKOhJf+WOgoxJclFz3kgn//dBA+ya1GhurNn8zb//9NNutNuhz31f////9vt///z+IdAEAAAK4LQIAKobHItEIYCGAExBwe8jcToF9zIKrEdDYIuP2MgOWFSE34wYiR5iqQPj0JIeoVdlG4VD4XA67mAcNa1fhzA1jwHuTRxDUQ//iYBczjHiTJcIuPyKlHQkv/LHQUYkuSi57yQT//uggfZNajQ3Vmz+Zt//+mm3Wm3Q576v////+32///5/EOgAAADVghQAAAAA//uQZAUAB1WI0PZugAAAAAoQwAAAEk3nRd2qAAAAACiDgAAAAAAABCqEEQRLCgwpBGMlJkIz8jKhGvj4k6jzRnqasNKIeoh5gI7BJaC1A1AoNBjJgbyApVS4IDlZgDU5WUAxEKDNmmALHzZp0Fkz1FMTmGFl1FMEyodIavcCAUHDWrKAIA4aa2oCgILEBupZgHvAhEBcZ6joQBxS76AgccrFlczBvKLC0QI2cBoCFvfTDAo7eoOQInqDPBtvrDEZBNYN5xwNwxQRfw8ZQ5wQVLvO8OYU+mHvFLlDh05Mdg7BT6YrRPpCBznMB2r//xKJjyyOh+cImr2/4doscwD6neZjuZR4AgAABYAAAABy1xcdQtxYBYYZdifkUDgzzXaXn98Z0oi9ILU5mBjFANmRwlVJ3/6jYDAmxaiDG3/6xjQQCCKkRb/6kg/wW+kSJ5//rLobkLSiKmqP/0ikJuDaSaSf/6JiLYLEYnW/+kXg1WRVJL/9EmQ1YZIsv/6Qzwy5qk7/+tEU0nkls3/zIUMPKNX/6yZLf+kFgAfgGyLFAUwY//uQZAUABcd5UiNPVXAAAApAAAAAE0VZQKw9ISAAACgAAAAAVQIygIElVrFkBS+Jhi+EAuu+lKAkYUEIsmEAEoMeDmCETMvfSHTGkF5RWH7kz/ESHWPAq/kcCRhqBtMdokPdM7vil7RG98A2sc7zO6ZvTdM7pmOUAZTnJW+NXxqmd41dqJ6mLTXxrPpnV8avaIf5SvL7pndPvPpndJR9Kuu8fePvuiuhorgWjp7Mf/PRjxcFCPDkW31srioCExivv9lcwKEaHsf/7ow2Fl1T/9RkXgEhYElAoCLFtMArxwivDJJ+bR1HTKJdlEoTELCIqgEwVGSQ+hIm0NbK8WXcTEI0UPoa2NbG4y2K00JEWbZavJXkYaqo9CRHS55FcZTjKEk3NKoCYUnSQ0rWxrZbFKbKIhOKPZe1cJKzZSaQrIyULHDZmV5K4xySsDRKWOruanGtjLJXFEmwaIbDLX0hIPBUQPVFVkQkDoUNfSoDgQGKPekoxeGzA4DUvnn4bxzcZrtJyipKfPNy5w+9lnXwgqsiyHNeSVpemw4bWb9psYeq//uQZBoABQt4yMVxYAIAAAkQoAAAHvYpL5m6AAgAACXDAAAAD59jblTirQe9upFsmZbpMudy7Lz1X1DYsxOOSWpfPqNX2WqktK0DMvuGwlbNj44TleLPQ+Gsfb+GOWOKJoIrWb3cIMeeON6lz2umTqMXV8Mj30yWPpjoSa9ujK8SyeJP5y5mOW1D6hvLepeveEAEDo0mgCRClOEgANv3B9a6fikgUSu/DmAMATrGx7nng5p5iimPNZsfQLYB2sDLIkzRKZOHGAaUyDcpFBSLG9MCQALgAIgQs2YunOszLSAyQYPVC2YdGGeHD2dTdJk1pAHGAWDjnkcLKFymS3RQZTInzySoBwMG0QueC3gMsCEYxUqlrcxK6k1LQQcsmyYeQPdC2YfuGPASCBkcVMQQqpVJshui1tkXQJQV0OXGAZMXSOEEBRirXbVRQW7ugq7IM7rPWSZyDlM3IuNEkxzCOJ0ny2ThNkyRai1b6ev//3dzNGzNb//4uAvHT5sURcZCFcuKLhOFs8mLAAEAt4UWAAIABAAAAAB4qbHo0tIjVkUU//uQZAwABfSFz3ZqQAAAAAngwAAAE1HjMp2qAAAAACZDgAAAD5UkTE1UgZEUExqYynN1qZvqIOREEFmBcJQkwdxiFtw0qEOkGYfRDifBui9MQg4QAHAqWtAWHoCxu1Yf4VfWLPIM2mHDFsbQEVGwyqQoQcwnfHeIkNt9YnkiaS1oizycqJrx4KOQjahZxWbcZgztj2c49nKmkId44S71j0c8eV9yDK6uPRzx5X18eDvjvQ6yKo9ZSS6l//8elePK/Lf//IInrOF/FvDoADYAGBMGb7FtErm5MXMlmPAJQVgWta7Zx2go+8xJ0UiCb8LHHdftWyLJE0QIAIsI+UbXu67dZMjmgDGCGl1H+vpF4NSDckSIkk7Vd+sxEhBQMRU8j/12UIRhzSaUdQ+rQU5kGeFxm+hb1oh6pWWmv3uvmReDl0UnvtapVaIzo1jZbf/pD6ElLqSX+rUmOQNpJFa/r+sa4e/pBlAABoAAAAA3CUgShLdGIxsY7AUABPRrgCABdDuQ5GC7DqPQCgbbJUAoRSUj+NIEig0YfyWUho1VBBBA//uQZB4ABZx5zfMakeAAAAmwAAAAF5F3P0w9GtAAACfAAAAAwLhMDmAYWMgVEG1U0FIGCBgXBXAtfMH10000EEEEEECUBYln03TTTdNBDZopopYvrTTdNa325mImNg3TTPV9q3pmY0xoO6bv3r00y+IDGid/9aaaZTGMuj9mpu9Mpio1dXrr5HERTZSmqU36A3CumzN/9Robv/Xx4v9ijkSRSNLQhAWumap82WRSBUqXStV/YcS+XVLnSS+WLDroqArFkMEsAS+eWmrUzrO0oEmE40RlMZ5+ODIkAyKAGUwZ3mVKmcamcJnMW26MRPgUw6j+LkhyHGVGYjSUUKNpuJUQoOIAyDvEyG8S5yfK6dhZc0Tx1KI/gviKL6qvvFs1+bWtaz58uUNnryq6kt5RzOCkPWlVqVX2a/EEBUdU1KrXLf40GoiiFXK///qpoiDXrOgqDR38JB0bw7SoL+ZB9o1RCkQjQ2CBYZKd/+VJxZRRZlqSkKiws0WFxUyCwsKiMy7hUVFhIaCrNQsKkTIsLivwKKigsj8XYlwt/WKi2N4d//uQRCSAAjURNIHpMZBGYiaQPSYyAAABLAAAAAAAACWAAAAApUF/Mg+0aohSIRobBAsMlO//Kk4soosy1JSFRYWaLC4qZBYWFRGZdwqKiwkNBVmoWFSJkWFxX4FFRQWR+LsS4W/rFRb/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////VEFHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAU291bmRib3kuZGUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMjAwNGh0dHA6Ly93d3cuc291bmRib3kuZGUAAAAAAAAAACU=')
            snd.play()
        },
        handleBulkItemScan() {
            this.resetBulkScanModeIfNeeded()
            // handle second phase of item bulk scan
            if (this.bulkScanModeEnabled && this.bulkScanItemCode === this.code) {
                return false
            }

            // handle first phase of item bulk scan
            const bulkScanDefaultQuantity = ShipmentItemService.getItemBulkScanDefaultQuantity(this.code)
            if (bulkScanDefaultQuantity) {
                this.bulkScanModeEnabled = true
                this.bulkScanQuantity = bulkScanDefaultQuantity - 1
                this.bulkScanItemCode = this.code
                this.playErrorSound()
            }

            return true
        },
        performBulkScan() {
            this.code = this.bulkScanItemCode
            this.quantity = this.bulkScanQuantity
            this.scan(true)
        },
        resetBulkScanModeIfNeeded() {
            if (this.bulkScanItemCode !== this.code) {
                this.resetBulkScanMode()
            }
        },
        resetBulkScanMode() {
            this.bulkScanModeEnabled = false
            this.quantity = 1
            this.bulkScanItemCode = ''
        },
        changeBox() {
            if (this.boxes[this.selectedBoxIndex]) {
                this.currentBox = this.boxes[this.selectedBoxIndex]
            }
        },
        addBox() {
            this.boxSaving = true
            const data = {
                shipment_id: this.shipmentId,
            }
            if (this.copySizes) {
                data.width = this.currentBox.width
                data.height = this.currentBox.height
                data.length = this.currentBox.length
                data.weight = this.currentBox.weight
            }
            Axios({url: `${process.env.VUE_APP_API_HTTP_ROOT}boxes/create`, data, method: 'POST'})
                .then(resp => {
                    const {box} = resp.data
                    this.boxes.push(box)
                    this.selectedBoxIndex = this.boxes.length - 1
                    this.boxSaving = false
                    this.currentBox = box
                })
                .catch(() => {
                    this.playErrorSound()
                    this.boxSaving = false
                })
        },
        tryToUpdateBox(box) {
            clearTimeout(this.boxUpdateTimeout)
            this.boxUpdateTimeout = setTimeout(() => {
                this.updateBox(box)
            }, 1000)
        },
        updateBox(box) {
            this.boxSavingWithoutDisable = true
            Axios({url: `${process.env.VUE_APP_API_HTTP_ROOT}boxes/update`, data: box, method: 'POST'})
                .then(() => {
                    this.boxSavingWithoutDisable = false
                })
                .catch(() => {
                    this.playErrorSound()
                    this.boxSavingWithoutDisable = false
                })
        },
        deleteBox() {
            // Not implemented yet, uncomment if needed. Should be working just fine.
            if (!this.currentBox.id) {
                return false
            }

            this.boxSaving = true
            Axios({
                url: `${process.env.VUE_APP_API_HTTP_ROOT}boxes/delete`,
                data: {id: this.currentBox.id},
                method: 'DELETE'
            })
                .then(() => {
                    this.$emit('box-deleted')
                    this.boxSaving = false
                    this.focusCodeInput()
                    this.deleteBoxModalOpen = false
                    this.removeBoxFromShipment(this.currentBox)
                    this.selectBoxFromLocalStorage()
                })
                .catch(err => {
                    this.playErrorSound()
                    this.boxSaving = false
                    this.handleScanError(err)

                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Error!',
                            icon: 'XIcon',
                            text: '' + this.errors,
                            variant: 'danger',
                        },
                    })
                })

            return true
        },
        removeBoxFromShipment(box) {
            this.boxes.splice(this.boxes.indexOf(box), 1)
            let counter = 1
            this.boxes.forEach(internalBox => {
                internalBox.index = counter
                counter += 1
            })
        },
        getLengthUnit() {
            // return this.units === Units.IMPERIAL ? 'in' : 'cm';
            return this.$store.getters.projectSettings.lengthUnit
        },
        getWeightUnit() {
            // return this.units === Units.IMPERIAL ? 'lb' : 'kg';
            return this.$store.getters.projectSettings.weightUnit
        },
    },

}
</script>
